var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4897 4.60979H12.5102C11.0103 4.60386 9.5678 5.18635 8.49253 6.23217C7.41727 7.27799 6.79488 8.70374 6.75916 10.2033V26.2668C6.72617 27.7889 7.29894 29.2618 8.35145 30.3619C9.40396 31.4619 10.8501 32.0991 12.3722 32.1333H24.4937C26.004 32.0707 27.431 31.424 28.4737 30.3295C29.5164 29.2351 30.0933 27.7784 30.0827 26.2668V12.5178L22.4897 4.60979Z",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0955 4.5918V8.95529C22.0951 9.97799 22.5005 10.9591 23.2227 11.6832C23.9448 12.4074 24.9248 12.8154 25.9475 12.8178H30.083",
    stroke: "#273239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8148 23.5051H13.7147",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7472 17.8759H13.7133",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResume);
export default __webpack_public_path__ + "static/media/ic_resume.c73389823b1265fe9bd1c1db10f0b9f3.svg";
export { ForwardRef as ReactComponent };